import type { Options } from 'recordrtc';

export const videoRecordingSettings: Options = {
  type: 'video',
  disableLogs: true,

  videoBitsPerSecond: 1250000,
  bitsPerSecond: 1250000,

  frameRate: 25,
  frameInterval: 40, // 25 fps (1000 / 25)
};
